import ContentRoutes from 'ContentUtils/Routes';
import { ListItem } from 'foundations-components/transitional/components/List';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';

// @ts-expect-error actions not typed yet
import { autoSave as autoSaveAction } from '../redux/actions/pageSaveActions';
import { getContentModelPersonalizationStrategyId } from '../redux/selectors/pageContentModelSelectors';
import VariantSelect from 'personalization-lib/components/variantSelect/VariantSelect';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
import { jsx as _jsx } from "react/jsx-runtime";
export const PersonalizationVariantControls = () => {
  const currentId = useSelector(getContentModelId);
  const personalizationStrategyId = useSelector(getContentModelPersonalizationStrategyId);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const dispatch = useDispatch();
  const onSelectVariant = useCallback(variantId => {
    const variantRoute = ContentRoutes.edit(variantId, CATEGORY_IDS.LANDING_PAGE);
    if (hasUnsavedChanges) {
      dispatch(autoSaveAction()).then(() => {
        window.location = variantRoute;
      }).catch(e => {
        console.error(e);
      });
    } else {
      window.location = variantRoute;
    }
  }, [dispatch, hasUnsavedChanges]);
  return /*#__PURE__*/_jsx(ListItem, {
    "data-test-id": "personalization-variant-controls",
    children: /*#__PURE__*/_jsx(VariantSelect, {
      value: currentId,
      strategyId: Number(personalizationStrategyId),
      onChange: onSelectVariant,
      onError: error => {
        Raven.captureMessage('[P13n] - Error fetching personalization variants', {
          extra: {
            error
          }
        });
      }
    })
  });
};